'use strict';

angular.module('header', []);
